import styled from 'styled-components';

export const Wrap = styled.div`
  display: flex;

  .filter-input {
    width: 93px;
  }

  ._spectrum-Dropdown-label_06fc4 {
    color: #8e8e8e;
    font-weight: 400;
    margin-right: 10px;
  }

  ._spectrum-Icon_8ac98._spectrum-UIIcon-ChevronDownMedium_8ac98._spectrum-Icon_7a745._spectrum-Dropdown-chevron_06fc4 {
    color: #8e8e8e;
  }

  ._spectrum-FieldButton_7a745._spectrum-Dropdown-trigger_06fc4 {
    background-color: white;
    width: var(--spectrum-global-dimension-size-1200);
  }

  ._spectrum-FieldLabel_36b9b {
    font-style: italic;
    font-size: 12px;
    color: #8e8e8e;
  }

  ._spectrum-Textfield-input_61339.filter-date {
    color: #8e8e8e;
  }

  ._spectrum-Field_36b9b._spectrum-Field--positionTop_36b9b {
    width: var(--spectrum-global-dimension-size-1700);
    color: #8e8e8e;
  }
`;

export const DivArrows = styled.div`
  position: absolute;
  display: flex;
  cursor: pointer;
  right: -34px;
  top: 28px;
`;

export const Input = styled.div`
  margin-right: 20px;
  width: 12%;
  position: relative;
`;

export const ButtonChangeCalendar = styled.button`
  width: 25px;
  height: 25px;
  display: flex;
  background: none;
  border: none;
  align-items: center;
  justify-content: center;
  color: #8e8e8e;
`;
